import { Observable, switchMap } from 'rxjs';

export const VOID = new Observable<void>((observer) => {
  observer.next();
  observer.complete();
});

export const switchMapToVoid = switchMap(() => VOID);
